export default "__VITE_ASSET__BTVlpDO6__"